import { createRoutine } from "redux-saga-routines";

export const visitsRoutine = createRoutine("API_VISITS_GET");
export const visitsAddRoutine = createRoutine("API_VISITS_ADD");
